<template>
  <router-link :to="route" class="refinance-row">
    <div class="cell">
      <h5>{{ user.name }}</h5>
      <p>{{ user.phoneNumber }}</p>
    </div>
    <div class="cell">
      <h5>บ้านเลขที่ {{ home.addressNumber }}</h5>
      <p>โครงการ {{ home.project }}</p>
    </div>
    <div class="cell currency">
      <h5>{{ loanAmount | money }} บาท</h5>
    </div>
    <div class="cell">
      <h5>{{ bankName }}</h5>
    </div>
    <div class="cell">
      <h5>{{ submittedToName }}</h5>
    </div>
    <div class="cell">
      <h5>{{ createdAt | date }}</h5>
    </div>
    <div class="cell">
      <h5 :class="css" class="current-status">{{ status }}</h5>
    </div>
  </router-link>
</template>

<script>
import Vue from "vue"
import { RefinanceStatus } from "../RefinanceStatus"

export default Vue.extend({
  props: {
    user: {
      type: null,
      default: undefined,
    },
    home: {
      type: null,
      default: undefined,
    },
    loanAmount: {
      type: null,
      default: undefined,
    },
    bankName: {
      type: null,
      default: undefined,
    },
    submittedToName: {
      type: null,
      default: undefined,
    },
    createdAt: {
      type: null,
      default: undefined,
    },
    status: {
      type: null,
      default: undefined,
    },
    route: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {}
  },
  computed: {
    css() {
      return { completed: this.isCompleted, rejected: this.isRejected }
    },
    isCompleted() {
      return this.status === RefinanceStatus.COMPLETED
    },
    isRejected() {
      return this.status === RefinanceStatus.REJECTED
    },
  },
})
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.refinance-row {
  display: grid;
  grid-template-columns: repeat(6, 1fr) 150px;
  grid-gap: 15px;
  align-items: center;

  padding: ($space / 3) $space;

  &:hover {
    background: #fafafa;
    cursor: pointer;
    text-decoration: none;
  }
}

.refinance-row > .cell {
  > h5 {
    font-size: 16px;
  }

  > p {
    font-size: 14px;
  }

  > h5,
  > p {
    line-height: 1.6;
    margin: 0;
  }

  &.currency > h5 {
    margin-right: 30px;
    text-align: right;
  }
}

.current-status {
  &.completed {
    color: $success-color;
  }

  &.rejected {
    color: $danger-color;
  }
}
</style>
